import { WCM_COMMENTS_EVENT } from "../articleHeaderComponenta/actionBarShared"

const siteArticleCommentsId = "SiteArticleComments"

interface CalcalistArticleRailCommentsProps {
    showComments: boolean
}

interface CalcalistArticleRailCommentsState {
    showComments: boolean
    wcmNumOfComments: string
}

export class CalcalistArticleRailComments extends React.Component<CalcalistArticleRailCommentsProps, CalcalistArticleRailCommentsState> {
    public static siteScriptName = "CalcalistArticleRailComments"

    constructor(props: CalcalistArticleRailCommentsProps) {
        super(props)
        this.state = {
            showComments: false,
            wcmNumOfComments: "",
        }
    }

    componentDidMount() {
        document.addEventListener(WCM_COMMENTS_EVENT, this.handleOnWcmCommentsRecived)
        this.setState({
            showComments: this.canShowComments(),
            wcmNumOfComments: typeof window !== "undefined" && window.wcmNumOfComments ? window.wcmNumOfComments : "",
        })
    }

    componentWillUnmount() {
        document.removeEventListener(WCM_COMMENTS_EVENT, this.handleOnWcmCommentsRecived)
    }

    private handleOnWcmCommentsRecived = (e: any) => {
        const wcmNumOfComments = e && e.detail && e.detail.wcmNumOfComments ? e.detail.wcmNumOfComments : ""
        this.setState({
            showComments: this.canShowComments(),
            wcmNumOfComments,
        })
    }

    private canShowComments = () => {
        return this.props.showComments && this.isTalkbackElement()
    }

    private isTalkbackElement = () => {
        if (typeof window !== "undefined") {
            return !!document.getElementById(siteArticleCommentsId)
        }
        return false
    }

    private openCommentsPopup = () => {
        if (typeof window !== "undefined" && window.handleCommentsPopupVisability) {
            window.handleCommentsPopupVisability()
            return
        }
        const commentsEl = document.getElementById(siteArticleCommentsId)
        if (commentsEl) {
            commentsEl.scrollIntoView({ behavior: "smooth" })
        }
    }

    render() {
        const { showComments, wcmNumOfComments } = this.state
        if (!showComments) {
            return null
        }

        return (
            <button
                type="button"
                className="calcalistArticleRailComments"
                title="תגובות"
                onClick={this.openCommentsPopup}
            >
                <span className="calcalistArticleRailCommentsCount">{wcmNumOfComments}</span>
                <span className="calcalistArticleRailCommentsTail"></span>
            </button>
        )
    }
}
